
import { useEffect, useState, useCallback } from "react"
import { motion } from "framer-motion"
import { QRCodeSVG } from "qrcode.react"
import { Button } from 'antd';
import CodeBlock from "./CodeBlock"
// import { Select } from "antd";
import { AlertCircle } from "lucide-react"
import { Toaster, toast } from 'sonner'
import { useSelector } from 'react-redux';
import { CheckCircle, MessageSquare, QrCode, Send, ArrowRight } from "lucide-react"
import { checkActiveSession, getContactRecentMessage } from "../../apis/Webhooks";

import { Light as SyntaxHighlighter } from "react-syntax-highlighter"
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs"

import { Input } from 'antd';
const { TextArea } = Input;

const steps = [
  {
    title: "1. Connect Sandbox",
    description: "Connect to the sandbox environment",
    icon: QrCode,
  },
  {
    title: "2. Business Initiated",
    description: "Send a business-initiated message",
    icon: Send,
  },
  {
    title: "3. Customer Initiated",
    description: "Test customer-initiated messaging",
    icon: MessageSquare,
  },
  {
    title: "4. Wrap Up",
    description: "View integration samples",
    icon: CheckCircle,
  },
]

const ChatbotTab = () => {

  const [currentStep, setCurrentStep] = useState(0)
  const [checkingActiveSession, setCheckingActiveSession] = useState(false)
  const [messageApiRespose, setMessgaeApiResponse] = useState();
  // const [template, setTemplate] = useState("authentication")

  const [contactInfo, setContactInfo] = useState()
  const [contactReplies, setContactReplies] = useState([])
  const [initialVisitTime, setInitialVisitTime] = useState(null);
  
  const selector = useSelector((state) => state.auth)
  const userDetails = JSON.parse(selector?.userInfo)
  const phoneNumber =  selector?.sandBoxNumber
  const joinCode = `join ${userDetails?.client?.sandboxJoinCode}`
  const userApiKey = JSON.parse(selector?.apiKey);

  const [toPhoneNumber, setToPhoneNumber] = useState("");
  const [messageBody, setMessageBody] = useState("")
  const [isLoading, setIsLoading] = useState();

  const handleWhatsAppRedirect = () => {
    window.open(`https://wa.me/254110090747?text=join%20${userDetails?.client?.sandboxJoinCode}`, "_blank")
  }

  const sendTestMessage = async () => {
    const messageData = {
        message: messageBody,
        messageId: crypto.randomUUID(),
        to: toPhoneNumber,
        from: "254110090747"
    };

    if(!messageData.to){
      toast.error('Please enter phone number!')
      return;
    }

    if(!messageData.message){
      toast.error('Please enter message body!')
      return;
    }
    
    try {
        setIsLoading(true);
        const response = await fetch('https://gateway.lipachat.com/api/v1/whatsapp/message/text', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apiKey': userApiKey
            },
            body: JSON.stringify(messageData)
        });

        const result = await response.json();
        if (response.ok) {
          toast.success('Message was successfully sent!')
          setIsLoading(false);

          var jsonResponse = JSON.stringify( result, null, 2)
          setMessgaeApiResponse(jsonResponse)
            
        } else {
           toast.error(`Failed to send message: ${result.error || "Unknown error"}`)
            setIsLoading(false);
        }
    } catch (error) {
        setIsLoading(false);
        toast.error("An error occurred while sending the message.")
    }
  };
   
  console.log(initialVisitTime)

  const getContactRecentReply = useCallback(async (sinceTime) => {
    try {
      const res = await getContactRecentMessage(contactInfo?.phoneNumber);
      if (res.status === 200) {
        const messages = res.data?.data || [];
        const filteredMessages = messages.filter(msg => msg.createdAt >= sinceTime);
        setContactReplies(filteredMessages);
      }
    } catch (err) {
      console.error("Error fetching replies:", err);
    }
  }, [contactInfo?.phoneNumber]);


  useEffect(() => {
    if (currentStep === 2) {
      const now = new Date().toISOString();
      setInitialVisitTime(now);
  
      const interval = setInterval(() => {
        console.log("Fetching latest replies.....")
        getContactRecentReply(now);
      }, 2000);
  
      return () => clearInterval(interval);
    }
  }, [currentStep, getContactRecentReply]);

 
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div className="space-y-0">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-lg font-medium mb-4">Step 1: Connect to Sandbox</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <p className="text-gray-600 mb-4">
                    Send the following code to connect to our sandbox number: <code className="bg-gray-100 px-2 py-0.5 rounded">+254110090747</code>
                  </p>
                  <div className="bg-gray-100 p-2 rounded-md mb-4">
                    <code className="text-md font-[600]">{joinCode}</code>
                  </div>
                  <Button 
                    onClick={handleWhatsAppRedirect}
                    className="w-full md:w-auto border-blue-500 py-4 text-blue-500"
                  >
                    Open in WhatsApp
                  </Button>
                </div>
                <div className="flex flex-col items-center">
                  <p className="text-gray-600 mb-4">Or scan this QR code:</p>
                  <QRCodeSVG 
                    value={`https://wa.me/${phoneNumber}?text=${joinCode}`}
                    size={200}
                    className="border-2 p-2 rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        )
      case 1:
        return (
          <div className="space-y-0 flex ">
            <div className="bg-white p-6 rounded-lg shadow-sm grow mr-2 max-h-max">
              <h3 className="text-lg font-medium mb-4">Step 2: Business Initiated Message</h3>
              <div className="space-y-4">
                <div >
                  <label className="block text-sm font-medium text-gray-700">From</label>
                  <div className="bg-gray-100 p-2 rounded-md mb-4">
                   <code className="w-full bg-gray-100 rounded-md">{phoneNumber}</code>
                 </div>
                </div>

                <div >
                  <label className="block text-sm font-medium text-gray-700">To</label>
                  <div className="bg-gray-100 p-2 rounded-md mb-4">
                   <code className="w-full bg-gray-100 rounded-md">{toPhoneNumber}</code>
                 </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">Message</label>
                  <TextArea placeholder="Enter message to send" rows={4} maxLength={200}  onChange={(e)=>setMessageBody(e.target.value)}/>
                </div>

                 <Button disabled={isLoading} onClick={()=>sendTestMessage()} className="w-full md:w-auto border-blue-500 py-4 text-blue-500">
                 {isLoading? "Sending..." : "Send Message"}</Button>
              </div> 
            </div>

            {/* showing both request and response in json form */}
            <div className="grow ml-2 bg-white p-4 rounded-lg shadow-sm max-w-[50%]">
              {/* request body */}
               <div className="space-y-4 mb-2">
                  <div className="rounded-lg overflow-hidden">
                    <p className="font-bold text-[16px]">Request Body</p>
                    <SyntaxHighlighter
                     
                      style={atomOneDark}
                      customStyle={{
                        padding: "1.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "0.875rem",
                      }}
                    >
                    {JSON.stringify( {
                        messageId: crypto.randomUUID(),
                        message: messageBody,
                        to: toPhoneNumber,
                        from: "254110090747"
                    }, null, 2)}
                   
                    </SyntaxHighlighter>
                  </div>
                </div>

                {/* response body */}
                <div className="space-y-4 max-w-full">
                  <div className="rounded-lg overflow-hidden">
                    <p className="font-bold text-[16px]">Response Body</p>
                    <SyntaxHighlighter
                     
                      style={atomOneDark}
                      customStyle={{
                        padding: "1.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "0.875rem",
                      }}
                    >
                     {messageApiRespose? messageApiRespose :"Your API response will appear here" }
                    </SyntaxHighlighter>
                  </div>
                </div>


              </div>

          </div>
        )
      case 2:
        return (
          <div className="space-y-0">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-lg font-medium mb-4">Step 3: Customer Initiated Message</h3>
              <p className="text-gray-600 mb-3">
                Send any message to our sandbox number:
              </p>
              <div className="bg-gray-100 p-2 rounded-md mb-4">
                <code className="w-full bg-gray-100 rounded-md">{phoneNumber}</code>
              </div>
              <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                <h4 className="font-medium mb-2">Response:</h4>
                <div className="bg-white p-3 rounded border">
                  {contactReplies.length === 0?
                  <p className="text-gray-600"> Waiting for your reply...</p>:
                  contactReplies?.map(reply => (
                    <p className="text-black-600 font-bold"><span className="text-gray-600 font-medium">You replied: </span>{reply?.text}</p>
                  ))
                }
                </div>
              </div>
            </div>
          </div>
        )
      case 3:
        return (
          <div className="space-y-0">
            <div className="bg-white p-6 rounded-lg shadow-sm">
            <h3 className="text-lg font-bold">Making API Requests</h3>
            <p className="text-gray-600 mb-6">
              Choose your preferred programming language below to see example code for sending messages
              using our WhatsApp API. Make sure to replace <code className="bg-gray-100 px-2 py-0.5 rounded">YOUR_API_KEY</code> with
              your actual API key. Go to settings page to see <code className="bg-gray-100 px-2 py-0.5 rounded">YOUR_API_KEY</code>
            </p>
            <CodeBlock />
           </div>
        </div>)
      default:
        return null
    }
  }


  const handleCheckActiveSession = () =>{
      const joinCode = userDetails?.client?.sandboxJoinCode;
      setMessgaeApiResponse("")
      setCheckingActiveSession(true)
      checkActiveSession(joinCode).then(resp =>{  
        if(resp?.data?.status === true){
          setCurrentStep(Math.min(steps.length - 1, currentStep + 1))
          setToPhoneNumber(resp.data?.session?.contact?.phoneNumber)
          setContactInfo(resp.data?.session?.contact)
        }else{
          toast.error("Please connect to sandbox by sending the join code!")
        }
      }).catch((error) => {
        toast.error("Something went wrong. Please try again later.");
      })
      .finally(() => {
        setCheckingActiveSession(false);
      });
  }

  const handleCheckActiveSessionFromTitles = (index) =>{
    const joinCode = userDetails?.client?.sandboxJoinCode;
     setMessgaeApiResponse("")
     setCheckingActiveSession(true)
     checkActiveSession(joinCode).then(resp =>{
      
       if(resp.data.status === true){
         setCurrentStep(index)
         setCheckingActiveSession(false)
         setToPhoneNumber(resp.data?.session?.contact?.phoneNumber)
       }else{
         toast.error("Please connect to sandbox by sending the join code!")
         setCheckingActiveSession(false)
       }
     })
 }

  return (
    <div className="space-y-8">

      <div className="flex items-start space-x-2 p-4 bg-blue-50 rounded-lg mb-6">
          <AlertCircle className="w-5 h-5 text-blue-500 mt-0.5" />
          <div className="text-sm text-blue-700">
            <p className="font-medium mb-1">Important Note:</p>
            <p>You must send a join code to proceed with onboarding and receive messages.</p>
          </div>
        </div>


      <div className="flex overflow-x-auto pb-0">
        {steps.map((step, index) => (
          <div key={step.title} className="flex items-center flex-1">
            <motion.div
              className="flex-1"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <button
                onClick={() => handleCheckActiveSessionFromTitles(index)}
                className={`w-full px-4 py-2 ${
                  currentStep === index
                    ? "text-blue-500"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <div className="flex flex-col items-center space-y-2">
                  <step.icon
                    className={`w-6 h-6 ${
                      currentStep === index ? "text-primary" : "text-gray-400"
                    }`}
                  />
                  <span className="text-sm font-medium">{step.title}</span>
                  <span className="text-xs text-gray-500 hidden md:block">
                    {step.description}
                  </span>
                </div>
              </button>
            </motion.div>
            {index < steps.length - 1 && (
              <div className="flex items-center justify-center px-2">
                <ArrowRight className="w-4 h-4 text-gray-400" />
              </div>
            )}
          </div>
        ))}
      </div>

      <motion.div
        key={currentStep}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
      >
        {renderStepContent(currentStep)}
      </motion.div>

      <div className="flex justify-between pt-0">
        <Button
          variant="outline"
          onClick={() => setCurrentStep(Math.max(0, currentStep - 1))}
          disabled={currentStep === 0}
        >
          Previous
        </Button>
        <Button
          onClick={handleCheckActiveSession}
          disabled={currentStep === steps.length - 1 || checkingActiveSession}
        >
          Next
        </Button>
      </div>
       <Toaster position="bottom-right" expand={false} richColors/>
    </div>
  )
}

export default ChatbotTab